import "core-js/modules/es.array.push.js";
import "@tonWallet/index";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "layout",
  inject: ["reload"],
  data() {
    const menuList = [{
      "name": "首页",
      "path": "/"
    }, {
      "name": "统计",
      "path": "/stat"
    }, {
      "name": "系统邀请",
      "path": "/ref"
    }, {
      "name": "客户邀请",
      "path": "/uref"
    }, {
      "name": "官方任务",
      "path": "/offitask"
    }, {
      "name": "扩展任务",
      "path": "/task"
    }, {
      "name": "广告列表",
      "path": "/adv"
    }, {
      "name": "其他任务",
      "path": "/othertask"
    }, {
      "name": "活动列表",
      "path": "/events"
    }, {
      "name": "充值列表",
      "path": "/rechargelist"
    }, {
      "name": "用户列表",
      "path": "/userlist"
    }, {
      "name": "推送任务",
      "path": "/pushtask"
    }];
    return {
      menuList,
      selectItem: "",
      unsubscribe: null
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile", 'setting']),
    ...walletVuex.mapGetters(["isWallet"]),
    route() {
      return this.$route.path;
    }
  },
  watch: {},
  methods: {
    onMenu(item) {
      this.selectItem = item;
      this.$router.push(item.path);
    }
  },
  mounted() {
    this.menuList.map(item => {
      if (item.path == this.$route.path) {
        this.selectItem = item;
      }
    });
  }
};